export function stripPTag(input?: string): string {
  if (!input) {
    return input;
  }

  // Regular expression to match <p> tags
  const regex = /<p>(.*?)<\/p>/gi;
  // Replace <p> tags with their content
  return input.replace(regex, '$1');
}

export function fromStrToElement(str: string) {
  if (!str) return null;

  const template = document.createElement('template');
  template.innerHTML = str.trim();

  const result = template.content.children;

  return result[0];
}

export function fromElementToStr(element: Element) {
  if (!element) return null;

  const ser = new XMLSerializer();
  return ser.serializeToString(element);
}
